import TiberLogo from "../../../../public/static/icons/tibertutor.svg";

export default function Logo({
  color = "#00bdf7",
  size = 40,
  className,
}: {
  color?: string;
  size?: number;
  className?: string;
}) {
  return (
    <TiberLogo
      fill={color}
      width={size}
      height={size}
      alt="Tiber Tutor"
      className={className}
    />
  );
}
